import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        active:
          "border-transparent bg-green-500 text-white hover:bg-green-500/80",
        completed:
          "border-transparent bg-blue-500 text-white hover:bg-blue-500/80",
        expired: "border-transparent bg-red-500 text-white hover:bg-red-500/80",
        inactive:
          "border-transparent bg-gray-500 text-white hover:bg-gray-500/80",
        "fully-refunded":
          "border-transparent bg-gray-400 text-white hover:bg-gray-400/80",
        "completed-with-partial-refund":
          "border-transparent bg-orange-500 text-white hover:bg-orange-500/80",
        transferred:
          "border-transparent bg-purple-500 text-white hover:bg-purple-500/80",
        converted:
          "border-transparent bg-teal-500 text-white hover:bg-teal-500/80",
        gifted: "border-[#e86c4e] text-[#e86c4e]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
